import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
  TextCell,
  ImageCell,
  LargeImageCell,
  ButtonCell,
  CarouselCell
} from './chat-cells';

import _ from 'lodash';
import {getUUID} from "../../utils/getUUID";

class ChatBody extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    this.refs.chatBody.scrollTop = this.refs.chatBody.scrollHeight;
    // this.refs.chatBody.animate({scrollTop: this.refs.chatBody.scrollHeight}, 600, 'linear')
  }
  componentDidMount() {

  }

  render() {
    const {messages} = this.props;
    return (
      <div ref={'chatBody'} className={'cu-ui-chat-body'}>
        {
          _.map(messages, (e) => {
            switch (e.type) {
              case "text":
                return <TextCell isBot={e.isBot} withIcon={e.withIcon} text={e.text} time={e.time} key={getUUID()}></TextCell>
              case "normal-image":
                return <ImageCell isBot={e.isBot} url={e.url} time={e.time} key={getUUID()}></ImageCell>
              case "large-image":
                return <LargeImageCell url={e.url} key={getUUID()}></LargeImageCell>
              case "button":
                return <ButtonCell text={e.text} isBot={e.isBot} time={e.time} buttons={e.buttons} buttonLayoutType={e.buttonType} key={getUUID()}></ButtonCell>
              case 'carousel':
                return <CarouselCell carousels={e.carousels} key={getUUID()}></CarouselCell>
            }
          })
        }
      </div>
    )
  }
}

ChatBody.propTypes = {
  messages: PropTypes.array
};

const mapStateToProps = (state, props) => ({
  messages: state.chatBody.messages
});

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatBody)


// WEBPACK FOOTER //
// ./src/components/chat-body/index.jsx